module.exports = __webpack_public_path__ + "images/icons/tick.2ada7a11a2b292bdd3c407b417bd3891.svg";